import { Drawer, IconButton, Typography, withStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { Button, ListCard } from 'bc-front-sagacomponents';
import React from 'react';
import Ouvrir from '../../../images/Ouvrir';
import { AdhesionAdherentParticulierResponse } from '../../../services/Api/swagger';
import history from '../../../services/history';
import styles from '../style';
import { isBefore } from 'date-fns';

interface Props {
  classes?: any;
  open: boolean;
  onDrawerOpen(): void;
  listeAdhesions?: AdhesionAdherentParticulierResponse[];
  selectedAdhesion?: AdhesionAdherentParticulierResponse;
  setSelectionAdhesion(param: AdhesionAdherentParticulierResponse): void;
  handleChangeProgramme(code: string): void;
  width: number;
}

function LeftDrawer(props: Props) {
  const {
    classes,
    open,
    onDrawerOpen,
    listeAdhesions,
    selectedAdhesion,
    setSelectionAdhesion,
    width,
    handleChangeProgramme,
  } = props;

  let drawerClass;
  let closingBtnClass;
  if (!open) {
    drawerClass = classes.drawerPaper + ' ' + classes.drawerClosed;
    closingBtnClass = classes.closingBtn + ' ' + classes.closingClosedBtn;
  } else {
    drawerClass = classes.drawerPaper + ' ' + classes.drawerOpened;
    closingBtnClass = classes.closingBtn + ' ' + classes.closingOpenedBtn;
  }

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={open}
      classes={{
        paper: drawerClass,
      }}
    >
      <div className={classes.drawerHeader}>
        {' '}
        <Button
          className={classes.btnRetour}
          onClick={() => history.push('/accueil')}
          title="Retour à l'accueil"
          variant="text"
          color="default"
          icon={<ArrowBack />}
        />
        <IconButton onClick={onDrawerOpen} className={closingBtnClass}>
          <Ouvrir width={12} />
        </IconButton>
      </div>
      <div className={classes.drawerFilter}>
        <Typography variant="body2" className={classes.titleDrawer}>
          Mes contrats
        </Typography>
      </div>

      <div className={classes.drawerList}>
        {listeAdhesions &&
          listeAdhesions.map((adhesion, i) => {
            const handleSelectedConcession = () => {
              adhesion.codeProgramme && handleChangeProgramme(adhesion.codeProgramme);

              setSelectionAdhesion(adhesion);
              if (width < 628) {
                onDrawerOpen();
              }
            };

            const textStatut =
              adhesion?.dateEcheance && isBefore(new Date(adhesion?.dateEcheance), new Date()) ? 'Terminé' : 'En cours';
            return (
              <ListCard
                key={adhesion.numeroAdhesion}
                title={
                  (adhesion?.marque &&
                    adhesion?.marque?.libelle + ' ' + adhesion?.modele + ' ' + adhesion?.immatriculation) ||
                  'Carte de fidélité N°' + adhesion?.numeroFidelite
                }
                id={adhesion && adhesion.numeroAdhesion}
                borderColor={'red'}
                activeItem={selectedAdhesion?.numeroAdhesion}
                onClick={handleSelectedConcession}
                subtitle={"N° d'adhésion : " + adhesion?.numeroAdhesion}
                etat={textStatut}
              />
            );
          })}
      </div>
    </Drawer>
  );
}
export default withStyles(styles)(LeftDrawer);
